<template>
    <div class="footer_introduce">
        <div class="margin">
            <div class="txt">Copyright © 2016 - 2019 <a style="color: inherit" href="http://beian.miit.gov.cn/">京ICP备16022346号-4</a>   京网文[2019]3780-364号</div>
            <div class="txt">增值电信业务经营许可证 京B2-20170093  <img src="../../images/batb.png" style="display: inline; margin: 0px 5px;vertical-align: middle;">京公网安备 11010502031685  统一社会信用代码：91110105MA004KEG3G</div>
            <div class="txt">健康游戏忠告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活</div>
            <div class="txt">未满18周岁的未成年人用户请在家长的监督下进行游戏</div>
            <div class="txt">举报邮箱：jubao@xianlai-inc.com</div>
            <p class="txt">北京闲徕互娱网络科技有限公司版权所有  地址：北京市朝阳区天朗园C座3层03商业3-008  电话：010-84935767转8818、010-84935767</p>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
    @import '../../components/style/mixin';
    .footer_introduce {
        width:100%;
        height:100%;
        background-color:#282828;
        .margin{
            padding:35px 0px;
            .txt{
                line-height:30px;
                text-align: center;
                @include sc(14px, #a1a1a1);
            }
        }
	}
</style>
